module.exports = __webpack_public_path__ + "img/contact_kefu.3f6c3a4a.png";